export default "__VITE_ASSET__Ba0iBnes__"